import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async get(id: number) {
    return wrapEndpoint(() => client.GET('/treatment/{id}', { params: { path: { id } } }))
  },

  async getFilters(diseaseId?: number) {
    return wrapEndpoint(() =>
      client.GET('/treatment/filters', {
        params: {
          query: {
            diseaseId,
          },
        },
      }),
    )
  },

  async list(options?: ApiSchemas['ListTreatmentDto']) {
    return wrapEndpoint(() =>
      client.GET('/treatment', {
        params: {
          query: options,
        },
      }),
    )
  },

  async create(body: ApiSchemas['CreateTreatmentDto']) {
    return wrapEndpoint(() => client.POST('/treatment', { body }))
  },

  async update(id: number, body: ApiSchemas['UpdateTreatmentDto']) {
    return wrapEndpoint(() =>
      client.PUT('/treatment/{id}', {
        body,
        params: { path: { id } },
      }),
    )
  },

  async delete(id: number) {
    return wrapEndpoint(() => client.DELETE('/treatment/{id}', { params: { path: { id } } }))
  },
}
